import { API_CALL } from './actionConstants'
import { FETCH_TOURV2_OFFER, FETCH_TOURV2_SNAPSHOT_DETAILS } from './apiActionConstants'
import { getSnapshotDetailsForTourV2Offer } from 'api/tourV2'
import * as OfferService from 'api/offer'

export function fetchTourV2Offer(offerId: string, privateRequestKey?: string, regionCode?: string) {
  return (dispatch, getState) => {
    const state: App.State = getState()

    const offerKey = privateRequestKey ? `${offerId}-${privateRequestKey}` : offerId

    if (state.offer.offersLoading[offerKey] ||
      state.offer.tourV2Offers[offerKey]) {
      return
    }
    dispatch({
      type: API_CALL,
      api: FETCH_TOURV2_OFFER,
      request: () =>
        OfferService.getOfferById(offerId, {
          region: regionCode || state.geo.currentRegionCode,
          privateRequestKey,
        }),
      offerId: offerKey,
    })
  }
}

export function fetchTourV2SnapshotDetails(reservationId: string) {
  return (dispatch, getState) => {
    const state: App.State = getState()

    if (state.order.tourV2SnapshotsLoading[reservationId] ||
      state.order.tourV2SnapshotDetails[reservationId]) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_TOURV2_SNAPSHOT_DETAILS,
      request: () =>
        getSnapshotDetailsForTourV2Offer({ reservationId }),
      reservationId,
    })
  }
}
